'use strict';

var ExtractMetricKeysService = function ExtractMetricKeysService() {
  function extract(object) {
    return Object.keys(object).filter(function (key) {
      return /^m[1-9][0-9]*/.test(key);
    });
  }
  return {
    extract: extract
  };
};
module.exports = ExtractMetricKeysService;